import { handleActions, combineActions } from 'redux-actions'
import { combineReducers } from 'redux'

import * as actions from './actions'

const status = handleActions({
  [combineActions(
    actions.setLoaded,
    actions.timedOut,
    actions.setPending
  )]: (state, action) => action.type,
}, false)

export default combineReducers({
  status,
})



// WEBPACK FOOTER //
// ./src/modules/experiment/reducer.js